import { getOwnedNftId } from 'entities/mine-package/api';
import { selectPackagesList } from 'entities/mine-package/model/selectors';
import { createAppAsyncThunk, logger } from 'shared';
import { Address } from 'viem';

import { actionTypes } from '../action-types';
import { actions } from '../reducer';

export const getOwnedNft = createAppAsyncThunk(
  actionTypes.GET_OWNED_PACKAGE,
  async (address: Address, { rejectWithValue, dispatch, getState }) => {
    try {
      const ownedNftId = await getOwnedNftId(address);

      if (ownedNftId !== null) {
        const packagesList = selectPackagesList(getState());
        const userPackage = packagesList.find((p) => p.contractId === ownedNftId);

        if (userPackage) {
          dispatch(actions.setOwnedPackage(userPackage));
          dispatch(actions.setOwnedNftId(ownedNftId));
        }
      }

      return null;
    } catch (err) {
      logger(actionTypes.GET_OWNED_PACKAGE, err);
      return rejectWithValue(err);
    }
  },
);
